<template>
    <div id="blocks-container--outer" class="scrollable-con">
        <RawDevelopment v-show="showRawDevelopment" />
        <ul id="blocks-container" class="adjustment-blocks-container ui-sortable"></ul>
    </div>
</template>

<script>
import RawDevelopment from "@/components/app/blocks/RawDevelopment/RawDevelopment.vue";
import { mapState } from "vuex";

export default {
    components: {RawDevelopment},
	computed: {
        ...mapState("UI", ['showRawDevelopment']),

    }
}
</script>

<style lang="scss" scoped>
#blocks-container--outer {
    //visibility: visible;
    position: relative;
    //overflow-y: scroll;
    //overflow-x: hidden;
    //scrollbar-width: none; // Firefox
    //&::-webkit-scrollbar {
    //    display: none;
    //}

    //padding: 15px;
    //transition: opacity 0.5s ease-in, visibility 0.5s ease-in;
    transition: none;

    #blocks-container {
        padding: 0;
    }
}
</style>